import React, {useEffect, useRef, useState} from 'react'
import {LoaderEllipsisComponent} from "../../../components/elements/Loader/LoaderComponent"
import {Card, CardBody, Button,  IconButton, Input, Typography, Tooltip,} from '@material-tailwind/react';
import api from '../../../js/api';
import {FieldArray, Form, Formik} from "formik";
import {PRICE_SALE, setMoney} from "../../../utils/shared";
import {toastInfo} from "../../../js/toast";
import {MagnifyingGlassIcon} from "@heroicons/react/24/solid";
import {BeakerIcon, CircleStackIcon, CubeIcon, ScaleIcon} from "@heroicons/react/24/outline";
import ModalDividir from './ModalDividir'


export function SearchProduct(props) {
  const {warehouseSelected} = props;
  const [products, setProducts] = useState([]);
  const [didMount, setMount] = useState(false);
  const [localLoader, setLocalLoader] = useState(false);
  const [showModalDividir, setShowModalDividir] = useState(false);
  const [itemProd, setItemProd] = useState({});
  let searchRef = useRef()

  useEffect(() => {
    setMount(true);
  }, [])

  useEffect(() => {
    if (didMount && warehouseSelected.value) {
      let e = {target: {value: ''}}
      search(e)
    }
  }, [didMount, warehouseSelected])

  const search = (e, research=false) => {
      const params = {
        search: e.target.value,
        warehouse_id: warehouseSelected?.value,
        page_size: 10
      }
      setLocalLoader(true)
      api.get('product-presentation', params)
        .then((response) => {
          setProducts(response.data.results);
        })
        .catch(() => {
        })
        .finally(() => {
          setLocalLoader(false)
          if(research){
          searchRef.current.value = e.target.value
          }
        });
      // }
  }

  const addProduct = (element) => {
    const condition = element.price_type ?? PRICE_SALE;
    const price = element.prices.find((price) => price.price_type === condition)?.amount ?? 0;
    if (!element.inventario.quantity) {
      toastInfo('Producto sin existencia')
      return;
    }

    props.addItem({
      id: element.id, // id de la presentación del producto
      name: element.name, // nombre del producto concatenado con su presentacion
      price_type: condition, // id del tipo de precio
      quantity: 1,
      product_id: element.product_id,
      price: price, // precio final seleccionado
      options_prices: element.prices, // arreglo de precios
      stock: element.inventario.quantity, // existencia
      product_warehouse: element.inventario.id, // inventario
      warehouse: element.inventario.warehouse_id // bodega
    })
    searchRef.current.value = ''
  }

  const toogleShowDividirProd = ()=> setShowModalDividir(!showModalDividir); 
  
  const showItemAdividir = (itemProd)=> {
    setItemProd(itemProd)
    setShowModalDividir(!showModalDividir)
  }; 


  return (
    <Card className='border rounded-none border-black/40 min-h-[500px] h-[510px] max-h-[550px]'>
      <div className="flex flex-row px-4 pt-4 ">
        <Input
          inputRef={searchRef}
          className="col !mt-[0.5px] !border-black/30"
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              search(event)
            }
          }}
          icon={<div className="w-5 mt-[-10px] opacity-80"><MagnifyingGlassIcon/></div>}
          placeholder="Buscar producto..."
          type='text'
        />
      </div>
      <span className="px-4 w-fit bottom-0 font-light text-end text-black/70 text-[11px]">
        Esta búsqueda se realizara en la bodega:
        {props?.warehouseSelected?.label}
        </span>
      <CardBody className="px-0 h-full max-h-[400px] overflow-y-auto">
        <ResultProductPresentation
          products={products}
          loader={localLoader}
          addProduct={addProduct}
          showItemAdividir={showItemAdividir}
        />
        <ModalDividir 
          itemProd={itemProd}
          open={showModalDividir}
          handler={toogleShowDividirProd}
          research={search}
         >
      </ModalDividir>
      </CardBody>
    </Card>
  )

}


export const ResultProductPresentation = ({products, addProduct, loader, showItemAdividir}) => {

  const dividirProducto = (itemP)=>{
    showItemAdividir(itemP)
  }
  
  
  return (
  <div className="">

    <Formik
      enableReinitialize={true}
      initialValues={{products: products}}
      onSubmit={values => {
      }}
    >
      <Form>
        <FieldArray
          name="presentations"
          render={({form}) =>
            <div className="grid gap-2 grid-cols-[repeat(auto-fit,_minmax(45%,_1fr))] px-3">
              <LoaderEllipsisComponent loader={loader}/>
              {
                form.values.products.map((item, index) => (
                  <Card
                    key={index}
                    className="w-full p-2 border h-full rounded-none cursor-pointer min-w-[185px] max-w-[280px] gap-y-1"
                  >
                    <div onClick={() => addProduct(form.values.products[index])}>
                      <div className="flex flex-row gap-y-2 gap-x-1.5 opacity-80">
                        <CubeIcon className="w-5 h-5 text-black"/>
                        <Typography className="" variant="small" color="black">
                          {item.name.replace(/\s*\([^)]*\)/g, '')}
                        </Typography>
                      </div>

                      <div className="flex flex-row gap-y-2 gap-x-1.5 opacity-80">
                        <BeakerIcon className="w-5 h-5 text-black"/>
                        <Typography variant="small" className="" color="black">
                          {unidadDeMedida(item.name)}
                        </Typography>
                      </div>

                      <div className="flex flex-row gap-y-2 gap-x-1.5 opacity-80">
                        <CircleStackIcon className="w-5 h-5 text-black"/>
                        <Typography  variant="small" className='text-right lg:md:2xl:xl:justify-end'>
                          {setMoney(item?.prices[0]?.amount * 1)}
                        </Typography>
                      </div>
                    </div>
                    {
                      (item.divisible && item?.inventario?.quantity == 0) &&
                      <Tooltip
                       content={"No se puede dividir el prodcuto por falta de existencia"}
                       placement="top"
                       >
                        <Button 
                          type='button'
                          onClick={()=>{}}
                          className={`py-1 text-[11px] w-fit flex flex-row justify-center px-2 bg-blue-gray-50 text-black right-1`}>
                            <ScaleIcon className="w-4 h-4 mr-2"></ScaleIcon> Dividir
                        </Button>
                      </Tooltip>
                    }
                    {
                    (item.divisible && item?.inventario?.quantity > 0) &&
                      <Button 
                        type='button'
                        onClick={()=>dividirProducto(item)}
                        className={`py-1 text-[11px] w-fit flex flex-row justify-center px-2 bg-blue-gray-50 text-black right-1`}>
                          <ScaleIcon className="w-4 h-4 mr-2"></ScaleIcon> Dividir
                      </Button>
                    }
                  </Card>
                ))
              }
            </div>
          }
        />
      </Form>
    </Formik>
  </div>
  )
}


function unidadDeMedida(texto) {
  const match = texto.match(/\(([^)]+)\)/);
  return match ? match[1] : null
}


function hiddenClassScale(pp) {
  //  Primer if, si no es Libras que oculte el boton para dividir
  if(pp.unit !=="3"){
    return 'hidden' 
  }
  let texto = pp?.name ?? ""
  let medida  = texto.match(/\(([^)]+)\)/)[1];
  var regexDigitos = /(\d+)/g;
  let medidaNumero = medida.match(regexDigitos)[0]
  //  Si su unidad de medida es libra, debe ser mayor a una libra
  if(medidaNumero > 1){
    return ''
  }

  return 'hidden'
}